<script>
    // ICP A2A 付款結果查詢中繼頁
    // OPAPP 返回首頁後由 Home.svelte 導向此頁，負責查詢訂單付款狀態並轉址至 /op-icp-result
    // PayStatus: 2=成功, -21=取消, -22=失敗, 0=尚未完成（webhook 尚未到達，最多重試 2 次）
    import { apiConfig, layoutOption } from '../store/inapp-store'
    import { Loader } from '../components'
    import { onMount } from 'svelte'

    $layoutOption.showBanner = false
    $layoutOption.showCarousel = false

    const SIX_MINUTES_MS = 6 * 60 * 1000

    let loader = { content: '交易確認中...' }
    let isBlock = true

    onMount(() => {
        const pendingJson = localStorage.getItem('icp_a2a_pending')
        if (!pendingJson) {
            location.href = `/op-icp-result?TradeResultCode=0`
            return
        }

        let pending
        try {
            pending = JSON.parse(pendingJson)
        } catch(e) {
            localStorage.removeItem('icp_a2a_pending')
            location.href = `/op-icp-result?TradeResultCode=0`
            return
        }

        localStorage.removeItem('icp_a2a_pending')

        if (Date.now() - pending.timestamp > SIX_MINUTES_MS) {
            location.href = `/op-icp-result?TradeResultCode=0`
            return
        }

        queryOrderResult(pending.orderId, 2)
    })

    function queryOrderResult(orderId, retries) {
        fetch(`${$apiConfig.apiUrl}/order?code=${$apiConfig.apiKey}&id=${orderId}`)
            .then(response => response.json())
            .then(d => {
                if (d.returnCode === '0000' && d.info && d.info.length > 0) {
                    const payStatus = d.info[0].payStatus
                    if (payStatus === 2) {
                        location.href = `/op-icp-result?TradeResultCode=1`
                        return
                    }
                    if (payStatus === -22 || payStatus === -21) {
                        location.href = `/op-icp-result?TradeResultCode=4`
                        return
                    }
                    if (retries > 0) {
                        setTimeout(() => queryOrderResult(orderId, retries - 1), 2000)
                        return
                    }
                }
                location.href = `/op-icp-result?TradeResultCode=0`
            })
            .catch(() => {
                location.href = `/op-icp-result?TradeResultCode=0`
            })
    }
</script>

<Loader {loader} {isBlock}></Loader>
